export default {"src":"/_next/static/media/realize-your-customers.e300439e.svg","height":532,"width":738,"blurWidth":0,"blurHeight":0};